import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Grid, Loader, Popup} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {getNumericValue} from '../../../../common/util/fieldsValidation';
import Header from './header';
import PartCode from './partCode';
import PartQuantity from './partQuantity';
import DeleteIcon from './deleteIcon';
import RestoreIcon from './restoreIcon';

class SuggestionsTable extends Component {
  constructor(props) {
    super(props);
    this.handleAddClick = this.handleAddClick.bind(this);
  }

  handleBackOrderClick(partCode) {
    this.props.showOrderPartBackOrder(partCode);
  }

  handleOnOrderClick(partCode) {
    this.props.showOrderPartOnOrder(partCode);
  }

  handleSOQClick(partCode) {
    this.props.showOrderPartSOQResume(partCode);
  }

  handleAddClick() {
    this.props.addSuggestedOrderElement();
  }

  renderTableBody() {
    const {loading, suggestedOrders} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='16'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!suggestedOrders.length) {
      return (
        <Table.Row>
          <Table.Cell colSpan='16'>
            No se encontraron registros.
          </Table.Cell>
        </Table.Row>
      );
    }
    
    return suggestedOrders.map((order, index) => this.renderSuggestedItem(order, index));
  }

  renderSuggestedItem(order, index) {
    return (
      <Table.Row key={index} negative={!!order.unattended || order.deleted}>
        <Table.Cell textAlign='center'>
          {this.renderRejection(order.rejectionCode, order.rejectionDescription)}
        </Table.Cell>
        <Table.Cell textAlign='center'>
          <PartCode order={order} index={index} />
        </Table.Cell>
        <Table.Cell textAlign='center'>
          {order.ICC}
        </Table.Cell>
        <Table.Cell textAlign='center'>
          {order.scc}
        </Table.Cell>
        <Table.Cell textAlign='right'>
          {order.salesMad}
        </Table.Cell>
        <Table.Cell textAlign='right'>
          {this.renderBackOrderLink(order.partCode, order.bo)}
        </Table.Cell>
        <Table.Cell textAlign='right'>
          {order.oh}
        </Table.Cell>
        <Table.Cell textAlign='right'>
          {this.renderOnOrderLink(order.partCode, order.oo)}
        </Table.Cell>
        <Table.Cell textAlign='right'>
          {order.billImportationValue}
        </Table.Cell>
        <Table.Cell textAlign='right'>
          {order.obs}
        </Table.Cell>
        <Table.Cell textAlign='right'>
          {this.renderSOQLink(order.partCode, order.partQuantitySuggested)}
        </Table.Cell>
        <Table.Cell textAlign='right'>
          {order.soqOrders}
        </Table.Cell>
        <Table.Cell textAlign='center'>
          <PartQuantity index={index} order={order} />
        </Table.Cell>
        <Table.Cell textAlign='right'>
          $ {getNumericValue(order.unitFob, 2)}
        </Table.Cell>
        <Table.Cell textAlign='right'>
          $ {getNumericValue(order.totalFob, 2)}
        </Table.Cell>
        <Table.Cell textAlign='center'>
          {this.renderIcon(order)}
        </Table.Cell>
      </Table.Row>
    );
  }

  renderIcon(order) {
    if (!order.deleted) {
      return (<DeleteIcon order={order} />);
    }

    return (<RestoreIcon order={order} />);
  }

  renderRejection(code, description) {
    return (
      <Popup inverted content={description} trigger={<span>{code || 'V'}</span>} />
    );
  }

  renderBackOrderLink(partCode, backOrder) {
    if (parseInt(backOrder, 10) === 0) {
      return 0;
    }

    return (
      <a onClick={this.handleBackOrderClick.bind(this, partCode)}>
        {backOrder}
      </a>
    );
  }

  renderOnOrderLink(partCode, onOrder) {
    if (parseInt(onOrder, 10) === 0) {
      return 0;
    }

    return (
      <a onClick={this.handleOnOrderClick.bind(this, partCode)}>
        {onOrder}
      </a>
    );
  }

  renderSOQLink(partCode, SOQ) {
    return (
      <a onClick={this.handleSOQClick.bind(this, partCode)}>
        {SOQ}
      </a>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className='tde-suggested-order-table'>
          <Table striped sortable>
            <Table.Header>
              <Header />
            </Table.Header>
            <Table.Body>
              {this.renderTableBody()}
            </Table.Body>
          </Table>
        </div>
        <Grid>
          <Grid.Row>
            <Grid.Column width='16' textAlign='left'>
              <a onClick={this.handleAddClick}><strong>Agregar Registro</strong></a>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const {loadingSuggestions, generating} = state.providerStockOrders;

  return {
    'loading': loadingSuggestions || generating,
    'suggestedOrders': state.providerStockOrders.filteredOrders,
  };
};

const {
  editSuggestedOrderPartQuantity,
  showOrderPartBackOrder,
  showOrderPartSOQResume,
  showOrderPartOnOrder,
  addSuggestedOrderElement,
} = Actions;

export default connect(mapStateToProps, {
  editSuggestedOrderPartQuantity,
  showOrderPartBackOrder,
  showOrderPartSOQResume,
  showOrderPartOnOrder,
  addSuggestedOrderElement,
})(SuggestionsTable);
